import * as c from '../constants/actionTypes';

let initialState = {
  email: '',
  email2: '',
  valid_email: false,
  affiliate_code: '',
  address: '',
  new: false,
  loggedin: false,
  first_name: '',
  last_name: '',
  phone: '',
  role: false,
  signup_date: '',
  hstnumber: '',
  hstprovince: '',
  balance: 0,
  fetched: false
}

export default (state = initialState, action) => {
  switch (action.type) {
    case c.VALIDATE_EMAIL:
      var newState = state;
      newState.email = action.email;
      newState.valid_email = true;
      return state = Object.assign({}, state, newState);
    case c.INVALIDATE_EMAIL:
      var newState = state;
      // newState.email = '';
      newState.valid_email = false;
      return state = Object.assign({}, state, newState);
    case c.UPDATE_USER_EMAIL:
      var newState = state;
      newState.email = action.email;
      return state = Object.assign({}, state, newState);
    case c.LOGIN_STUDENT_SUCCESS:
      var newState = state;
      newState.loggedin = true;
      newState.email = action.body.user.email;
      newState.role  = action.body.user.role ;
      return state = Object.assign({}, state, newState);
    case c.LOGOUT_SUCCESS:
      var newState = state;
      newState.loggedin = false;
      newState.role = false;
      return state = Object.assign({}, state, newState);
    case c.USER_SESSION_SUCCESS:
      var newState = state;
      newState.loggedin = true;
      newState.email = action.body.user.email;
      newState.role  = action.body.user.role ;
      newState.signup_date = action.body.user.signup_date;
      newState.hstnumber = action.body.user.hst_number;
      newState.hstprovince = action.body.user.hst_province;
      newState.phone = action.body.user.phone;
      newState.first_name = action.body.user.first_name;
      newState.last_name = action.body.user.last_name;
      newState.affiliate_code = action.body.user.affiliate_code;
      newState.balance = action.body.user.balance;
      newState.fetched = true;
      return state = Object.assign({}, state, newState);
    case c.USER_SESSION_ANON_FETCHED:
      var newState = state;
      newState.fetched = true;
      return state = Object.assign({}, state, newState);
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/User.js